<template>
  <div class="criteria-wrapper">
    <div class="row custom-margin-top-30">
      <div class="col-12">
        <div class="d-flex align-items-center">
          <span class="text-uppercase font-weight-600">
            Level {{ level }}
          </span>

          <b-dropdown
            v-if="totalItem > 1 && !isEscalate"
            no-caret
            dropright
            v-ripple.400="'rgba(30, 30, 30, 0.15)'"
            text="Dark"
            variant="flat-dark"
            size="sm"
            class="custom-margin-left-6"
          >
            <template #button-content>
              <feather-icon icon="MoreVerticalIcon"></feather-icon>
            </template>
            <b-dropdown-item v-if="level !== 1" @click="clickMoveUp">
              <div class="d-flex align-items-center">
                <feather-icon icon="ArrowUpIcon" class="mr-1"></feather-icon>
                <span>Move Up</span>
              </div>
            </b-dropdown-item>
            <b-dropdown-item v-if="level !== totalItem" @click="clickMoveDown">
              <div class="d-flex align-items-center">
                <feather-icon icon="ArrowDownIcon" class="mr-1"></feather-icon>
                <span>Move Down</span>
              </div>
            </b-dropdown-item>
            <b-dropdown-divider />
            <b-dropdown-item @click="clickRemove">
              <div class="d-flex align-items-center text-color-danger">
                <feather-icon icon="Trash2Icon" class="mr-1"></feather-icon>
                <span>Remove</span>
              </div>
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </div>

      <div class="col-12 col-md-6 mt-1">
        <atom-select
          v-model="criteria.contactName"
          title="Name"
          placeholder="Select Name"
          :option="userOptions"
          :isClearable="false"
          :isAsterisk="true"
          :isPushTaggable="true"
          :isError="isContractNameError"
          errorMessage="Please select contract name"
          @input="changeContractName"
        ></atom-select>
      </div>
      <div class="col-12 col-md-6 mt-1">
        <atom-input
          v-model="criteria.contactRole"
          title="Role"
          placeholder="Role"
          errorMessage="Please input role"
          :isAsterisk="true"
          :isError="isRoleError"
        ></atom-input>
      </div>
      <div class="col-12 col-md-6 mt-1">
        <atom-select
          v-model="criteria.contactEmail"
          title="Contact Email"
          placeholder="Select Email"
          label="email"
          :option="emailOptions"
          :isClearable="false"
          :isAsterisk="true"
          :isPushTaggable="true"
          :isError="isContractEmailInvalid || isContractEmailError"
          :errorMessage="errorMessageEmail"
          @input="changeContractEmail"
        ></atom-select>
      </div>
      <div class="col-12 col-md-6 mt-1">
        <atom-select
          v-model="criteria.contactPhone"
          title="Contact Phone"
          placeholder="Select Phone"
          label="phone"
          :option="phoneOptions"
          :isClearable="false"
          :isAsterisk="true"
          :isPushTaggable="true"
          :isError="isContractPhoneInvalid || isContractPhoneError"
          :errorMessage="errorMessageContractPhone"
          @input="changeContractPhone"
        ></atom-select>
      </div>
    </div>

    <div v-if="level > 1" class="row">
      <div class="col-12 col-md-3 mt-1">
        <div class="d-flex align-items-center">
          <atom-input
            v-model="criteria.escalationTimeDays"
            title="Escalation Time"
            type="number"
            :isAsterisk="true"
            placeholder="0"
            :isError="isErrorTime"
          ></atom-input>
          <span class="custom-margin-left-10 custom-margin-top-18">
            Day(s)
          </span>
        </div>
      </div>
      <div class="col-12 col-md-3 mt-1">
        <div class="d-flex align-items-center">
          <atom-input
            class="mt-2"
            v-model="criteria.escalationTimeHours"
            type="number"
            :isAsterisk="true"
            placeholder="0"
            :isError="isErrorTime"
          ></atom-input>
          <span class="custom-margin-left-10 custom-margin-top-18">
            Hour(s)
          </span>
        </div>
      </div>
      <div class="col-12 col-md-3 mt-1">
        <div class="d-flex align-items-center">
          <atom-input
            class="mt-2"
            type="number"
            v-model="criteria.escalationTimeMinutes"
            :isAsterisk="true"
            placeholder="0"
            :isError="isErrorTime"
          ></atom-input>
          <span class="custom-margin-left-10 custom-margin-top-18">
            Minute(s)
          </span>
        </div>
      </div>
      <div v-if="isErrorTime" class="col-12 text--error">
        Please input escalation time
      </div>
    </div>

    <div class="row custom-margin-top-30">
      <div class="col-12 mt-2">
        <span class="font-weight-500">Default Notification Settings</span>
      </div>

      <div class="col-12 mt-2">
        <div class="d-flex align-items-center ml-md-3">
          <div class="custom-margin-top-2">
            <atom-switch
              v-model="criteria.enableSystemNotification"
              :isDisable="isDisableNotificationSystem"
            ></atom-switch>
          </div>
          <div
            class="d-flex notification-topic align-items-center ml-2"
            :class="{
              'notification-active': criteria.enableSystemNotification,
            }"
          >
            <div class="icon-wrapper">
              <feather-icon icon="BellIcon" />
            </div>
            <div
              :class="{
                'text-semibold-primary': criteria.enableSystemNotification,
              }"
            >
              <span class="d-flex d-sm-none notification ml-1"> System </span>
              <span class="d-none d-sm-flex notification ml-1">
                System Notification
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 mt-1">
        <div class="row ml-md-3">
          <div
            class="col-12 col-md-5 col-lg-4 d-flex align-items-center px-md-0 pt-2"
          >
            <atom-switch
              v-model="criteria.enableEmailNotification"
            ></atom-switch>

            <div class="ml-2">
              <div
                class="d-flex align-items-center notification-topic"
                :class="{
                  'notification-active': criteria.enableEmailNotification,
                }"
              >
                <div class="icon-wrapper">
                  <feather-icon icon="MailIcon" />
                </div>
                <div
                  :class="{
                    'text-semibold-primary': criteria.enableEmailNotification,
                  }"
                >
                  <span class="d-flex d-sm-none notification ml-1">
                    Email
                  </span>
                  <span class="d-none d-sm-flex notification ml-1">
                    Email Notification
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div v-if="isShowEmail" class="col-12 col-md-7 col-lg-8 mt-1 mt-md-0">
            <atom-select
              v-model="criteria.emailAddress"
              title="Email"
              placeholder="Select Email Notification"
              label="email"
              :option="emailOptions"
              :isClearable="false"
              :isAsterisk="criteria.enableEmailNotification"
              :isDisable="!criteria.enableEmailNotification"
              :isPushTaggable="true"
              :isError="isEmailNotificationInvalid || isEmailNotificationError"
              :errorMessage="errorMessageEmailNotification"
              @input="changeNotificationEmail"
            ></atom-select>
          </div>
        </div>
      </div>

      <div class="custom-line mt-3"></div>
    </div>
  </div>
</template>

<script>
import Ripple from "vue-ripple-directive"
import { BDropdown, BDropdownItem, BDropdownDivider } from "bootstrap-vue"

import AtomInput from "@/components/atoms/AtomInput.vue"
import AtomSelect from "@/components/atoms/AtomSelect.vue"
import AtomSwitch from "@/components/atoms/AtomSwitch.vue"
import AtomTextArea from "@/components/atoms/AtomTextArea.vue"
import mixinsValidator from "@/mixins/mixinsValidator"

export default {
  name: "MoleculeCriteriaDetail",
  components: {
    BDropdown,
    BDropdownItem,
    BDropdownDivider,
    AtomInput,
    AtomSelect,
    AtomSwitch,
    AtomTextArea,
  },
  directives: {
    Ripple,
  },
  mixins: [mixinsValidator],
  props: {
    escalationTemplateId: {
      type: [String, null],
      required: false,
      default: null,
    },
    value: {
      type: Object,
      required: true,
    },
    level: {
      type: Number,
      required: true,
    },
    userOptions: {
      type: Array,
      required: false,
      default: () => [],
    },
    emailOptions: {
      type: Array,
      required: false,
      default: () => [],
    },
    phoneOptions: {
      type: Array,
      required: false,
      default: () => [],
    },
    totalItem: {
      type: Number,
      required: false,
      default: 0,
    },
    isEscalate: {
      type: Boolean,
      required: false,
      default: false,
    },
    isShowValidate: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ["input", "upLevel", "downLevel", "removeLevel"],
  data() {
    return {
      isContractEmailInvalid: false,
      isEmailNotificationInvalid: false,
      isContractPhoneInvalid: false,
      isDisableNotificationSystem: true,
    }
  },
  computed: {
    criteria: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit("input", value)
      },
    },

    isContractNameError() {
      return this.isShowValidate && !this.criteria?.contactName?.label?.trim()
    },
    isRoleError() {
      return this.isShowValidate && !this.criteria?.contactRole?.trim()
    },
    isContractPhoneError() {
      return this.isShowValidate && !this.criteria?.contactPhone?.phone?.trim()
    },
    errorMessageContractPhone() {
      if (this.isContractPhoneError) return "Please select contract phone"
      if (this.isContractPhoneInvalid) return "Contract phone invalid format"
      return ""
    },
    isContractEmailError() {
      return this.isShowValidate && !this.criteria?.contactEmail?.email?.trim()
    },
    errorMessageEmail() {
      if (this.isContractEmailError) return "Please select email"
      if (this.isContractEmailInvalid) return "Email invalid format"
      return ""
    },
    isEmailNotificationError() {
      return (
        this.isShowValidate &&
        this.criteria.enableEmailNotification &&
        !this.criteria?.emailAddress?.email?.trim()
      )
    },
    errorMessageEmailNotification() {
      if (this.isEmailNotificationError) return "Please select email"
      if (this.isEmailNotificationInvalid) return "Email invalid format"
      return ""
    },

    isErrorTime() {
      return (
        this.isShowValidate &&
        !(
          this.criteria.escalationTimeDays ||
          this.criteria.escalationTimeHours ||
          this.criteria.escalationTimeMinutes
        )
      )
    },

    isShowEmail() {
      return (
        this.criteria.enableEmailNotification ||
        this.criteria?.emailAddress ||
        this.criteria?.emailAddress?.email?.trim()
      )
    },

    isShowLineTokenInput() {
      return this.criteria.lineTokenAlias || this.criteria.lineToken
    },
  },
  watch: {
    criteria: {
      deep: true,
      immediate: true,
      handler() {
        const isError =
          !this.criteria?.contactName?.label?.trim() ||
          !this.criteria.contactRole?.trim() ||
          !this.criteria?.contactEmail?.email?.trim() ||
          !this.criteria?.contactPhone?.phone?.trim() ||
          this.isContractPhoneInvalid ||
          this.isContractEmailInvalid ||
          (this.level > 1 &&
            !this.criteria?.escalationTimeDays &&
            !this.criteria?.escalationTimeHours &&
            !this.criteria?.escalationTimeMinutes) ||
          (this.criteria.enableEmailNotification &&
            (!this.criteria?.emailAddress?.email?.trim() ||
              this.isEmailNotificationInvalid))
        this.$emit("isErrorLevel", isError, this.level)
      },
    },

    "criteria.contactName": {
      deep: true,
      immediate: true,
      handler() {
        this.isDisableNotificationSystem = Boolean(
          !this.criteria.contactName?.username
        )
      },
    },
  },
  methods: {
    clickMoveUp() {
      this.$emit("upLevel", this.level, this.criteria)
    },
    clickMoveDown() {
      this.$emit("downLevel", this.level, this.criteria)
    },
    clickRemove() {
      this.$emit("removeLevel", this.level, this.criteria)
    },

    changeContractName(selectedOption) {
      if (selectedOption?.username) {
        this.criteria.enableSystemNotification = true
        this.$emit("changeContractName", selectedOption, this.level)
      } else {
        this.criteria.enableSystemNotification = false
      }
    },

    changeContractPhone(selectedOption) {
      this.isContractPhoneInvalid = false
      if (!selectedOption?.phone) {
        this.criteria.contactPhone = {
          phone: selectedOption,
        }
      }

      if (!selectedOption?.isPrimary) {
        this.isContractPhoneInvalid = !this.isNumeric(
          selectedOption?.phone || selectedOption
        )
      }
    },

    changeContractEmail(selectedOption) {
      this.isContractEmailInvalid = false
      if (!selectedOption?.email) {
        this.criteria.contactEmail = {
          email: selectedOption,
        }
      }

      if (!selectedOption?.isPrimary) {
        this.isContractEmailInvalid = this.isInvalidEmail(
          selectedOption?.email || selectedOption
        )
      }
    },

    changeNotificationEmail(selectedOption) {
      this.isEmailNotificationInvalid = false
      if (!selectedOption?.email) {
        this.criteria.emailAddress = {
          email: selectedOption,
        }
      }

      if (!selectedOption?.isPrimary) {
        this.isEmailNotificationInvalid =
          this.criteria.enableEmailNotification &&
          this.isInvalidEmail(selectedOption?.email || selectedOption)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.icon-wrapper::v-deep .feather {
  width: 14px;
  height: 14px;
}

.icon-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
  border-radius: 6px;
  background-color: #f6f7f8;
  color: #b9b9c3;
}

.notification-topic {
  width: 280px;
}

.notification-input-width {
  width: clamp(100px, 300px, 400px);
}

.notification-active .icon-wrapper {
  background-color: #eeecfd;
  color: #7367f0;
}

.custom-line {
  height: 1px;
  width: 100%;
  margin: 0 14px;
  border-bottom: 1px solid #e9ecef;
}

.text--error {
  color: #ea5455;
  font-size: 12px;
  margin-top: 4px;
  line-height: 1.5;
}
</style>
